/** @jsx onetext.jsx.element */

import type { OneText } from '../../../global';

// eslint-disable-next-line no-restricted-syntax
import {
    NewYearBallons, NewYearBow, NewYearChampagne, NewYearCrown, NewYearHat,
    NewYearRibbon1, NewYearRibbon2, NewYearStar, NewYearStarWithRibbon
} from '../images';

declare let onetext : OneText;

const { clsx } = onetext.jsx;

export const BrandBackgroundNewYear = () : JSX.Element => (
    <div className={ 'absolute inset-0 overflow-hidden' }>
        { /* Top Left */ }
        <img
            src={ NewYearBallons }
            className={
                clsx(
                    'absolute',
                    'top-[-20px] left-[-10px] w-[100px]',
                    'xl:w-[180px]',
                    'transform rotate-[-15deg]'
                )
            } />
        <img
            src={ NewYearRibbon2 }
            className={
                clsx(
                    'absolute',
                    'left-20 xl:left-44 top-6 w-[50px]',
                    'xl:w-[80px]',
                    'transform rotate-[-15deg]'
                )
            } />
        { /* Top Right */ }
        <img
            src={ NewYearHat }
            className={
                clsx(
                    'absolute',
                    'xl:top-[20px] xl:right-[40px]',
                    'top-[-20px] right-[-10px] w-[100px]',
                    'xl:w-[180px]',
                    'transform rotate-[-15deg]'
                )
            } />
        <img
            src={ NewYearRibbon1 }
            className={
                clsx(
                    'absolute',
                    'top-24 xl:top-0 right-10 w-[45px]',
                    'xl:w-[85px]',
                    'transform rotate-[-15deg]'
                )
            } />

        { /* Bottom Left */ }
        <img
            src={ NewYearChampagne }
            className={
                clsx(
                    'absolute',
                    'bottom-[20px]  w-[135px]',
                    'xl:bottom-[80px] xl:w-[200px]',
                    'transform rotate-[5deg]'
                )
            } />
        <img
            src={ NewYearBow }
            className={
                clsx(
                    'absolute',
                    'bottom-[5%] left-[8%] w-[45px]',
                    'xl:bottom-[15%] xl:left-[10%] xl:w-[75px]',
                    'transform rotate-[20deg]'
                )
            } />
        <img
            src={ NewYearStar }
            className={
                clsx(
                    'absolute hidden xl:block',
                    'left-[3%] w-[70px]',
                    'xl:bottom-10'
                )
            } />

        { /* Bottom Right */ }
        <img
            src={ NewYearCrown }
            className={
                clsx(
                    'absolute',
                    'bottom-[14%] right-4 w-[65px]',
                    'xl:bottom-[20%]',
                    'transform rotate-[-25deg]'
                )
            } />
        <img
            src={ NewYearStarWithRibbon }
            className={
                clsx(
                    'absolute',
                    'bottom-[3%] right-[2%] w-[80px]',
                    'xl:bottom-[4%] xl:w-[140px]'
                )
            } />

        <img
            src={ NewYearRibbon2 }
            className={
                clsx(
                    'absolute hidden xl:block ',
                    '-bottom-10  xl:right-[8%] w-[40px]',
                    'xl:w-[120px]'
                )
            } />

    </div>
);
